<script lang="ts">
    import type {IAddress} from "../../interfaces";
    import {createEventDispatcher} from "svelte";

    export let data: IAddress = {
        id: null,
        address: '',
        details: '',
        city: null,
        department: null
    };

    export let departments: Array<any> = [];

    let dispatch = createEventDispatcher();

    function cancel() {
        dispatch('cancel')
    }

    function onSubmit() {
        dispatch('save', {
            id: data.id,
            address: data.address,
            details: data.details,
            department: data.department,
            city: data.city
        });
    }
</script>

<section class="mb-2">
    <div class="container">
        <div class="container max-w-900px mx-auto">
            <strong>Agregar nueva dirección</strong>
            <div on:click={cancel} class="box pointer"
                 style="font-family: sans-serif; font-size: 25px; font-weight: 300">
                &times;
            </div>
        </div>
        <div>
            <div class="naui-field mb-1">
                <input bind:value={data.address} class="naui-input" placeholder="Dirección">
            </div>
            <div class="box sx-ii">
                <div class="naui-field mb-1 w-100">
                    <select bind:value={data.department} class="naui-input">
                        <option value="{null}" selected hidden>Departamento</option>
                        {#each departments as d}
                            <option value={d}>{d.departamento}</option>
                        {/each}
                    </select>
                    <span></span>
                </div>
                <div class="naui-field mb-1 w-100">
                    <select bind:value={data.city} class="naui-input">
                        <option value="{null}" selected hidden>Ciudad</option>
                        {#if data.department}
                            {#each data?.department?.cities as c}
                                <option value={c}>{c.name}</option>
                            {/each}
                        {/if}
                    </select>
                    <span></span>
                </div>
            </div>
            <div class="naui-field mb-1">
                <textarea bind:value={data.details}
                          class="naui-input"></textarea>
            </div>
            <div class="box mt-15">
                <div on:click={onSubmit}
                     class="btn accent">
                    GUARDAR
                </div>
            </div>
        </div>
    </div>
</section>